/* unplugin-vue-components disabled */import script from "./PersonalConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalConfirm.vue?vue&type=script&setup=true&lang=js"

import "./PersonalConfirm.vue?vue&type=style&index=0&id=6ba87346&lang=scss&scoped=true"
import "./PersonalConfirm.vue?vue&type=style&index=1&id=6ba87346&lang=css"

import exportComponent from "/Users/yaogengzhu/Documents/soft-open/software-platform/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba87346"]])

export default __exports__